import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import VideoGenerator from './components/VideoGenerator';
import OtherModels from './components/OtherModels';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
// FixStoragePage is no longer needed in the UI
import Header from './components/Header';
import NeonMeshBackground from './components/NeonMeshBackground';
import './index.css';

function App() {
  return (
    <Router>
      <div className="relative min-h-screen bg-gray-900 overflow-hidden">
        <NeonMeshBackground />
        <div className="relative z-10">
          <Header />
          <Routes>
            <Route path="/" element={<VideoGenerator />} />
            <Route path="/other-models" element={<OtherModels />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;